const defaultServices = [
  {
    _id: 'default-1',
    title: 'General Checkup',
    description: 'Comprehensive health assessment including vital signs, lab testing, and preventive counseling.',
    price: 49,
    isActive: true
  },
  {
    _id: 'default-2',
    title: 'Cardiology',
    description: 'Heart health exam, ECG, and diagnostic support with top cardiologists.',
    price: 129,
    isActive: true
  },
  {
    _id: 'default-3',
    title: 'Dental Care',
    description: 'Routine exam, cleaning, and dental hygiene plan with restorative dentistry options.',
    price: 89,
    isActive: true
  },
  {
    _id: 'default-4',
    title: 'Pediatric Care',
    description: 'Trusted health services for infants, children, and teens, including vaccination tracking.',
    price: 59,
    isActive: true
  },
  {
    _id: 'default-5',
    title: 'Orthopedic Consultation',
    description: 'Expert evaluation of joint and muscle conditions with personalized treatment plan.',
    price: 99,
    isActive: true
  }
]

export default defaultServices
